<template>
  <div
    v-if="products.some(variant => variant.glutenFree)"
    class="grocerybag-checkbox checkbox"
  >
    <input
      :id="name + '-gluten'"
      v-model="glutenFreeData"
      type="checkbox"
      class="checkbox__input"
      :disabled="!isGlutenFreeAvailable"
    >
    <label
      :for="name + '-gluten'"
      class="checkbox__label"
    >Gluten- och laktosfri</label>
  </div>
  <div
    v-else-if="products.some(variant => variant.lactoseFree)"
    class="grocerybag-checkbox checkbox"
  >
    <input
      :id="name + '-lactose'"
      v-model="lactoseFreeData"
      type="checkbox"
      class="checkbox__input"
      :disabled="!isLactoseFreeAvailable"
    >
    <label
      :for="name + '-lactose'"
      class="checkbox__label"
    >Laktosfri</label>
  </div>
  <div
    v-else
    class="checkbox checkbox__empty"
  />
</template>

<script>
export default {
  name: 'GroceryBagOrderCheckBox',
  props: {
    products: {
      type: Array,
      default:() => {}
    },
    name: {
      type: String,
      default:""
    },
    glutenFree: {
      type: Boolean,
      default:null
    },
    lactoseFree: {
      type: Boolean,
      default:null
    },
    isGlutenFreeAvailable: {
      type: Boolean,
      default:null
    },
    isLactoseFreeAvailable: {
      type: Boolean,
      default:null
    },
  },
  data () {
    return {
      lactoseFreeData: this.lactoseFree,
      glutenFreeData: this.glutenFree
    }
  },
  watch: {
    lactoseFreeData (val) {
      this.$emit('lactoseFreeChange', val)
    },
    glutenFreeData (val) {
      this.$emit('glutenFreeChange', val)
    }
  },
}
</script>

<style lang="scss">
  .grocerybag-checkbox.checkbox {
    height: auto;
  }

  .checkbox {
    margin-left: -0.375rem;
    margin-bottom: 0.5rem;
    align-items: baseline;
    padding: 0.25rem 0;

    &__label {
      @include font(text, 3, "normal");

      margin-left: 0.25rem;
    }

    input[type="checkbox"]:disabled + label {
      color: $color-grey-mid;
      cursor: not-allowed;
    }

    &__empty {
      height: 2rem;
    }
  }
</style>
